import { Content } from "@/types/PropTypes";
import Container from "../Container";
import {
  ContentMarkup,
  AdsWrapper,
  AdsMobileWrapper,
  DeleteAccountBtn,
  ContentMarkupWrapper,
} from "./HowDeleteAccount.components";
import AdsDesktopPanel from "../AdsDesktopPanel";
import AdsMobileBanner from "../AdsMobileBanner";
import { useState } from "react";
import { DeleteAccountModal } from "../modal";
import isUserAuthorized from "@/helpers/isUserAuthorized";

const HowDeleteAccount: React.FC<Content> = ({ content }) => {
  const [isOpenModalDeleteAccount, setIsOpenModalDeleteAccount] = useState<boolean>(false);
  const isBtnDeleteDisabled = !isUserAuthorized();

  const deleteAccountText = "delete account";

  const handleClickDeleteAccountBtn = () => setIsOpenModalDeleteAccount(true);
  const onCloseCliced = () => setIsOpenModalDeleteAccount(false);
  return (
    <>
      <Container>
        <AdsWrapper>
          <ContentMarkupWrapper>
            <ContentMarkup content={content} />
            <DeleteAccountBtn
              onClick={handleClickDeleteAccountBtn}
              title={deleteAccountText}
              disabled={isBtnDeleteDisabled}
            />
          </ContentMarkupWrapper>

          <AdsDesktopPanel />
        </AdsWrapper>
      </Container>

      <AdsMobileWrapper>
        <AdsMobileBanner />
      </AdsMobileWrapper>

      <DeleteAccountModal isOpen={isOpenModalDeleteAccount} onCloseClicked={onCloseCliced} />
    </>
  );
};

export default HowDeleteAccount;
